
(function () {
  'use strict';

  function isEnglish(box) {
    var language = box.getAttribute('data-bs-language');

    if (language) {
      return language.toLowerCase() === 'en';
    }

    return (
      document.documentElement.lang || 'lt'
    ).toLowerCase().split('-')[0] === 'en';
  }

  function formatMoney(value, english) {
    return english
      ? '€' + new Intl.NumberFormat('en-IE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value)
      : new Intl.NumberFormat('lt-LT', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value) + ' €';
  }

  function updateGiftProgress() {
    var boxes = document.querySelectorAll('[data-bs-gift-progress]');

    if (!boxes.length) return;

    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to fetch cart');
        }

        return response.json();
      })
      .then(function (cart) {

        var total =
          typeof cart.items_subtotal_price === 'number'
            ? cart.items_subtotal_price / 100
            : cart.total_price / 100;

        boxes.forEach(function (box) {
          renderGiftProgress(box, total);
        });

      })
      .catch(function (error) {
        console.warn('Bare Skin gift progress:', error);
      });
  }

  function renderGiftProgress(box, total) {
    var status = box.querySelector('[data-bs-status]');
    var fill = box.querySelector('[data-bs-fill]');
    var points = box.querySelectorAll('[data-threshold]');
    var english = isEnglish(box);

    if (!status || !fill) return;

    /*
      Paliekame originalų progreso skaičiavimą.
    */

    var progress = 0;

    if (total < 59) {

      progress = Math.min((total / 59) * 10, 10);

    } else if (total < 100) {

      progress =
        ((total - 59) / (100 - 59)) * 50;

    } else if (total < 150) {

      progress =
        50 +
        ((total - 100) / (150 - 100)) * 50;

    } else {

      progress = 100;
    }

    fill.style.width =
      Math.max(0, Math.min(progress, 100)) + '%';

    points.forEach(function (point) {
      var threshold =
        Number(point.getAttribute('data-threshold'));

      if (total >= threshold) {
        point.classList.add('is-reached');
      } else {
        point.classList.remove('is-reached');
      }
    });

    /*
      Dinaminiai pranešimai LT / EN.
    */

    if (total < 59) {

      status.innerHTML = english
        ? 'Spend <strong>' +
          formatMoney(59 - total, true) +
          '</strong> more to unlock your first gift'
        : 'Iki pirmos dovanos trūksta <strong>' +
          formatMoney(59 - total, false) +
          '</strong>';

    } else if (total < 100) {

      status.innerHTML = english
        ? 'Gift unlocked · Spend <strong>' +
          formatMoney(100 - total, true) +
          '</strong> more to reach the next level'
        : 'Dovana jau priklauso · iki kito lygio trūksta <strong>' +
          formatMoney(100 - total, false) +
          '</strong>';

    } else if (total < 150) {

      status.innerHTML = english
        ? 'Gifts unlocked · Spend <strong>' +
          formatMoney(150 - total, true) +
          '</strong> more to reach the next level'
        : 'Dovanos jau priklauso · iki kito lygio trūksta <strong>' +
          formatMoney(150 - total, false) +
          '</strong>';

    } else {

      status.innerHTML = english
        ? '<strong>You have unlocked the highest gift tier!</strong>'
        : '<strong>Jums priklauso aukščiausio lygio dovanos</strong>';
    }
  }

  function setupGiftProgress() {
    var boxes = document.querySelectorAll('[data-bs-gift-progress]');

    boxes.forEach(function (box) {

      if (box.getAttribute('data-bs-ready') === 'true') {
        return;
      }

      box.setAttribute('data-bs-ready', 'true');

      var toggle = box.querySelector('[data-bs-toggle]');
      var details = box.querySelector('[data-bs-details]');
      var info = box.querySelector('[data-bs-info]');

      if (toggle && details) {

        toggle.addEventListener('click', function () {

          var isOpen =
            details.classList.toggle('is-open');

          toggle.setAttribute(
            'aria-expanded',
            isOpen ? 'true' : 'false'
          );

        });

      }

      if (info && toggle && details) {

        info.addEventListener('click', function () {

          details.classList.add('is-open');

          toggle.setAttribute(
            'aria-expanded',
            'true'
          );

        });

      }

    });

    updateGiftProgress();
  }

  /*
    Paleidimas užsikrovus puslapiui.
  */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      setupGiftProgress
    );

  } else {

    setupGiftProgress();

  }

  /*
    Krepšelio atnaujinimo įvykiai.
  */

  document.addEventListener(
    'cart:updated',
    updateGiftProgress
  );

  document.addEventListener(
    'cart:refresh',
    updateGiftProgress
  );

})();
